<template>
    <div class="page">
      <div class="page-header">
        <div class="header-text">
          <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
          <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
        </div>
      </div>
      <div class="page-content">
        <div>
          <h4 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h4>
          <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h4>
          <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h4>
          <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h4>
          <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h4>
          <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe6 ? focus.paragraphe6.titre : ''"></h4>
          <p v-html="focus.paragraphe6 ? focus.paragraphe6.texte : ''"></p>
        </div>
        <div>
          <h4 v-html="focus.paragraphe7 ? focus.paragraphe7.titre : ''"></h4>
          <p v-html="focus.paragraphe7 ? focus.paragraphe7.texte : ''"></p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getFocus } from '../../mixins/getFocus'
  
  export default {
    name: 'MentionsLegales',
    mixins: [getFocus],
    props: {
      siteCode: String
    },
    data() {
      return {
        focus: {},
      }
    },
    async beforeMount() {
      await this.getFocus(this.siteCode, 'Mentions Légales')
        .then(res => {
          this.focus = res
        })
    }
  }
  </script>
  
  <style lang="scss">
  .page-content {

    &>div{
      max-width: var(--max-width);
      width: 100%;
    }
  }
  </style>
  